(function(){
  // Grab BOTH search inputs: header and drawer
  const inputs = Array.from(document.querySelectorAll('.searchbox-input, .drawer-search input[type="search"], .drawer-search input[name="q"]'));
  if (!inputs.length) return;

  const endpointStr = (window.PREDICTIVE_SEARCH && window.PREDICTIVE_SEARCH.endpoint) || '/search/suggest';
  const searchUrlStr = (window.PREDICTIVE_SEARCH && window.PREDICTIVE_SEARCH.searchUrl) || '/search';

  function buildUrl(q, types) {
    const u = new URL(endpointStr, window.location.origin);
    u.searchParams.set('q', q);
    u.searchParams.set('section_id', 'predictive-search');
    u.searchParams.set('resources[type]', types.join(','));
    // Use a single limit for maximum compatibility
    u.searchParams.set('resources[limit]', '10');
    return u;
  }

  // Start by requesting pages+articles too; we'll fallback if needed
  let desiredTypes = ['product','collection','page','article'];
  let downgraded = false;
  

  let controller = null;
  let debounceId = null;

  function findHost(el){
    // Find the nearest predictive-search host relative to the input
    return el.closest('.drawer-search, #DrawerSearch')?.querySelector('.predictive-search-host')
        || document.getElementById('predictive-search-drawer')
        || el.closest('.section-header__inner')?.querySelector('.predictive-search-host')
        || document.getElementById('predictive-search-header')
        || document.querySelector('.predictive-search-host');
  }

  function openHost(host){
    if (!host) return;
    host.hidden = false;
    host.setAttribute('aria-expanded', 'true');
  }
  function closeHost(host){
    if (!host) return;
    host.innerHTML = '';
    host.hidden = true;
    host.setAttribute('aria-expanded', 'false');
  }

  function hydratePredictiveImages(rootEl){
    if (!rootEl) return;
    const imgs = rootEl.querySelectorAll('img[data-src], img[data-srcset], img.preload');
    imgs.forEach(img => {
      const ds = img.getAttribute('data-src');
      const dss = img.getAttribute('data-srcset');
      if (ds) img.setAttribute('src', ds);
      if (dss) img.setAttribute('srcset', dss);
      img.classList.remove('preload');
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
    });
    const sources = rootEl.querySelectorAll('picture source[data-srcset]');
    sources.forEach(source => {
      const dss = source.getAttribute('data-srcset');
      if (dss) source.setAttribute('srcset', dss);
    });
    // Color dots image swap fallback (optional)
    rootEl.querySelectorAll('.card-product .group-product button[data-image]').forEach(btn => {
      btn.addEventListener('click', () => {
        const mediaImg = btn.closest('.card-product')?.querySelector('.card-product__media img');
        const next = btn.getAttribute('data-image');
        if (mediaImg && next) mediaImg.src = next;
      }, { once: true });
    });
  }

  // Attach listeners to both inputs
  inputs.forEach(input => {
    const form = input.closest('form');
    const host = findHost(input);

    // Safety if no host found
    if (!host) return;

    // Start hidden
    closeHost(host);

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(debounceId);

      if (!q) { closeHost(host); return; }

      debounceId = setTimeout(async () => {
        try {
          if (controller) controller.abort();
          controller = new AbortController();

          const url = buildUrl(q, desiredTypes);
          let res = await fetch(url.toString(), { signal: controller.signal, headers: { 'Accept': 'text/html' }});

          if (res.status === 422 && !downgraded) {
            downgraded = true;
            desiredTypes = ['product','collection'];
            const fallbackUrl = buildUrl(q, desiredTypes);
            res = await fetch(fallbackUrl.toString(), { signal: controller.signal, headers: { 'Accept': 'text/html' }});
          }

          if (!res.ok) { closeHost(host); return; }

          const html = await res.text();
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          const results = tmp.querySelector('#predictive-search-results');
          if (!results) { closeHost(host); return; }

          host.innerHTML = '';
          host.appendChild(results);
          openHost(host);
          hydratePredictiveImages(host);

          const showAllBtn = host.querySelector('#searchbutton');
          if (showAllBtn) {
            showAllBtn.onclick = () => {
              const to = new URL(searchUrlStr, window.location.origin);
              to.searchParams.set('q', q);
              to.searchParams.set('type', 'product');
              window.location.assign(to.toString());
            };
          }
        } catch(e) {
          if (e.name !== 'AbortError') closeHost(host);
        }
      }, 200);
    });

    if (form) {
      form.addEventListener('submit', () => closeHost(host));
    }

    // Close when clicking outside this input/host pair
    document.addEventListener('click', (e) => {
      if (input.contains(e.target) || host.contains(e.target)) return;
      closeHost(host);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeHost(host); });
  });
})();
